import clsx from "clsx";

import { View } from ".";

type ProgressBarProps = {
  className?: string;
  progress?: number;
  variant?: "brand" | "success" | "warning" | "error";
};

export const ProgressBar = ({ className, variant = "brand", progress = 0 }: ProgressBarProps) => {
  return (
    <View className={clsx("w-full h-2 bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden", className)}>
      <View
        className={clsx("h-full rounded-full transition-all duration-200", {
          "bg-brand": variant === "brand",
          "bg-success dark:bg-success-light": variant === "success",
          "bg-warning dark:bg-warning-light": variant === "warning",
          "bg-error dark:bg-error-light": variant === "error",
        })}
        style={{
          width: `${Math.min(Math.max(0, progress), 100)}%` || "0%",
        }}
      />
    </View>
  );
};
